/* Build the HTTPS URL used to attempt browser client-certificate */
export function websocketAuthenticationUrl(websocketUrl) {
    try {
        const url = new URL(websocketUrl);
        if (url.protocol !== "wss:" || url.username || url.password || url.hash) return null;

        url.protocol = "https:";
        return url.href;
    } catch {
        return null;
    }
}
